var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrentBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.006,
    height: 31.006,
    viewBox: "0 0 31.006 31.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835",
    transform: "translate(-1787 -2764.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1834",
    "data-name": "Group 1834",
    transform: "translate(1787 2764.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 25.562,
    height: 25.562,
    transform: "translate(2.941 2.949)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M130.21,98.834v-2.4a.686.686,0,0,1,.045-.264.813.813,0,0,1,.665-.53.57.57,0,0,1,.134,0,.67.67,0,0,1,.261.06.812.812,0,0,1,.488.649.829.829,0,0,1,.006.089v2.4h2.4l.045,0a.688.688,0,0,1,.342.1.83.83,0,0,1,.076,1.352.844.844,0,0,1-.463.147h-2.4v2.4a.826.826,0,0,1-1.332.6.811.811,0,0,1-.261-.506.676.676,0,0,1,0-.089v-2.4h-2.4a.685.685,0,0,1-.347-.079.831.831,0,0,1-.116-1.372.845.845,0,0,1,.463-.148Z",
    transform: "translate(-108.094 -76.71)",
    fill: "#0072bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M19.093,3.174a11.149,11.149,0,0,1,1.835,13.354,11.374,11.374,0,0,1-5.455,4.852A.805.805,0,0,1,14.4,20.306c.169-.339.61-.459.975-.637a9.737,9.737,0,0,0,5.373-8.2A9.622,9.622,0,0,0,12.7,1.593l-.125-.023a.681.681,0,0,1-.369-.21A.825.825,0,0,1,12.544.031a1.361,1.361,0,0,1,.634.024A11.316,11.316,0,0,1,19.05,3.132ZM10.237.248a.832.832,0,0,1-.5,1.328l-.081.013A9.783,9.783,0,0,0,1.67,9.805,9.6,9.6,0,0,0,7.585,19.944l.066.03a.688.688,0,0,1,.312.288A.818.818,0,0,1,6.936,21.4,11.293,11.293,0,0,1,.207,13.248a11.355,11.355,0,0,1,2.942-9.98A11.259,11.259,0,0,1,9.462,0,1.123,1.123,0,0,1,10.237.248Z",
    transform: "translate(0 15.815) rotate(-45)",
    fill: "#0072bc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M1794.174,2774.3a13.179,13.179,0,0,1,1.584-1.788,17.253,17.253,0,0,1,1.986-1.376",
    transform: "translate(0.035 -0.022)",
    fill: "#0072bc",
    stroke: "#0072bc",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M5.184,9.9H8.576a.848.848,0,0,1,0,1.7H5.184a.846.846,0,0,1-.848-.848.848.848,0,0,0-1.7,0A2.542,2.542,0,0,0,5.184,13.3h.848v.848a.848.848,0,1,0,1.7,0V13.3h.848a2.542,2.542,0,0,0,2.544-2.544h0A2.542,2.542,0,0,0,8.576,8.208H5.184a.848.848,0,1,1,0-1.7H8.576a.846.846,0,0,1,.848.848.848.848,0,1,0,1.7,0A2.542,2.542,0,0,0,8.576,4.816H7.728V3.968a.848.848,0,1,0-1.7,0v.848H5.184A2.542,2.542,0,0,0,2.64,7.36h0A2.542,2.542,0,0,0,5.184,9.9Z",
    transform: "translate(1795.623 2770.947)",
    fill: "#0072bc",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentBalance);
export default __webpack_public_path__ + "static/media/current-balance.b5f7a0140aa3fba095eee4e485585d26.svg";
export { ForwardRef as ReactComponent };